import React from "react";

//package import

import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
  Typography,
  Box,
} from "@mui/material";
import {
  ProductionQuantityLimits as ProductionQuantityLimitsIcon,
  Category as CategoryIcon,
} from "@mui/icons-material";
import { NavLink, useLocation } from "react-router-dom";
import { listItemButtonClasses } from "@mui/material/ListItemButton";

//user import

import { adminRoutes, RoutesUrls } from "../../../../Services/Routes/APP";
import {
  DashBoardIcon,
  MinistryIcon,
  BatchIcon,
  SettingIcon,
  Logo,
} from "../../../../Svg";

//constants

const sideList = [
  {
    id: 331,
    title: "Dashboard",
    icon: <DashBoardIcon />,
    link: adminRoutes?.dashboard,
  },
  // {
  //   id: 3310,
  //   title: "Categories",
  //   icon: (
  //     <CategoryIcon
  //       sx={{
  //         color: "white",
  //       }}
  //     />
  //   ),
  //   link: adminRoutes?.categories,
  // },
  // {
  //   id: 3311,
  //   title: "Products",
  //   icon: (
  //     <ProductionQuantityLimitsIcon
  //       sx={{
  //         color: "white",
  //       }}
  //     />
  //   ),
  //   link: adminRoutes?.products,
  // },
  {
    id: 332,
    title: "Ministry",
    icon: <MinistryIcon />,
    link: adminRoutes?.ministry,
  },
  // {
  //   id: 433,
  //   title: "Batches",
  //   icon: <BatchIcon />,
  //   link: adminRoutes?.batch,
  // },

  {
    id: 336,
    title: "Setting",
    icon: <SettingIcon />,
    link: adminRoutes?.setting,
  },
];

//component

export const InsideDrawer = () => {
  //hooks

  const theme = useTheme();
  const location = useLocation();

  //render

  return (
    <Box>
      <Box padding={2}>
        <Typography
          color={"common.white"}
          variant="h4"
          fontWeight={"bold"}
          align="center"
        >
          <Logo />
        </Typography>
      </Box>
      <List>
        {sideList?.map((item, index) => (
          <NavLink
            key={`${item?.id}-user-route-${index}`}
            to={RoutesUrls?.admin + item?.link}
            style={{
              textDecoration: "none",
              color: "inherit",
            }}
            className={"active_link"}
          >
            <ListItemButton
              sx={{
                backgroundColor: "transparent",

                padding: theme.spacing(1.5, 1.5, 1.5, 4),
                [`&.${listItemButtonClasses.selected}`]: {
                  backgroundColor: "inherit !important",
                },
              }}
              selected={location?.pathname === RoutesUrls?.admin + item?.link}
            >
              <ListItemIcon sx={{ color: "inherit" }}>
                {item?.icon}
              </ListItemIcon>
              <ListItemText
                primary={item?.title}
                sx={{
                  color: theme.palette.common.white,
                }}
              />
            </ListItemButton>
          </NavLink>
        ))}
      </List>
    </Box>
  );
};
